import { render, staticRenderFns } from "./WebHostingPackage.vue?vue&type=template&id=e8b813be&"
import script from "./WebHostingPackage.vue?vue&type=script&lang=js&"
export * from "./WebHostingPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports